import { apiDeviceData, apiDeviceSession, apiNotification, apiSetting, firebaseApi } from './Consts';
const firebaseKey = "key=AAAA_kgigaM:APA91bE8LTstS5A5oFheBwveEKnQ1hGtdt_SXv6C3So4flocm51QpA3xuqvpzvtrrUwLFS9cJWUxqBoVpqMxWkNH7wyBj8AIp-rvQsQzPpK62_Tz3jKlOGKnSJneBTv-JioB38emJzfE";

export const getTokenData = () => {
    let tokenDetails = localStorage.getItem("token");
    return tokenDetails;
};
export const logout = () => {
    localStorage.clear();
    window.location.replace('')
};

export var updateEmail = (data) => {
    return fetch(apiSetting, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        }
    })
        .then(res => res.json())
        .then(
            (result) => {
                return result.result;
            },
            (error) => {
                return error;
            }
        )
}

// export var deviceDataAPI = (data) => {
//     return fetch(apiDeviceData, {
//         method: "GET",
//         body: JSON.stringify(data),
//         headers: {
//             Accept: "application/json",
//             'Content-Type': 'application/json',
//             Authorization: getTokenData(), // Ensure getTokenData() returns a valid token or an empty string if not available
//         }
//     })
//         .then(res => {
//             if (res.status === 401) { // Check if the response status is 401 (Unauthorized)
//                 logout(); // Call logout if unauthorized
//                 return Promise.reject('Unauthorized'); // Optionally reject the promise to stop further processing
//             }
//             return res.json();
//         })
//         .then((result) => {
//     return {
//         devices: result.devices,
//         lastKey: result.lastKey
//     };
// });
// }

export const deviceDataAPI = async (limit = 100, lastKey = null) => {
    try {
        // Construct query parameters properly
        const queryParams = new URLSearchParams({
            limit: limit.toString()
        });
        
        if (lastKey) {
            // Backend expects JSON string, URL-encoded
            queryParams.append('lastKey', encodeURIComponent(JSON.stringify(lastKey)));
        }
        
        const url = `${apiDeviceData}?${queryParams.toString()}`;
        
        
        
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": getTokenData() || "",
            },
        });

        // Handle 401 Unauthorized
        if (response.status === 401) {
            console.warn('Unauthorized - logging out');
            logout();
            throw new Error('Unauthorized');
        }

        // Handle non-2xx responses
        if (!response.ok) {
            const errorText = await response.text();
            console.error('API Error:', response.status, errorText);
            throw new Error(`API Error: ${response.status}`);
        }

        const result = await response.json();
        
        
        return {
            devices: result.devices || [],
            lastKey: result.lastKey || null,
            success: result.success
        };

    } catch (error) {
        console.error('deviceDataAPI failed:', error);
        // Re-throw so calling component can handle loading/error states
        throw error;
    }
};


export const deviceSessionAPI = async (id, limit = 100, lastKey = null) => {
    try {
        const queryParams = new URLSearchParams({
            limit: limit.toString()
        });

        if (lastKey) {
            queryParams.append(
                "lastKey",
                encodeURIComponent(JSON.stringify(lastKey))
            );
        }

        const url = `${apiDeviceSession}${id}?${queryParams.toString()}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": getTokenData() || "",
            },
        });

        if (response.status === 401) {
            logout();
            throw new Error("Unauthorized");
        }

        if (!response.ok) {
            throw new Error(`API Error: ${response.status}`);
        }

        const result = await response.json();

        return {
            success: result.success,
            sessions: result.sessions || [],
            lastKey: result.lastKey || null
        };

    } catch (error) {
        console.error("deviceSessionAPI failed:", error);
        throw error;
    }
};

// New function that auto-paginates and collects ALL sessions
export const fetchAllDeviceSessions = async (id, limit = 100) => {
    let allSessions = [];
    let lastKey = null;

    do {
        const result = await deviceSessionAPI(id, limit, lastKey);

        allSessions = [...allSessions, ...result.sessions];
        lastKey = result.lastKey;

        // If we got fewer results than the limit, there's no more data
        // OR if lastKey is null, the server says we're done
    } while (lastKey && allSessions.length < 10000); // safety cap to prevent infinite loops

    return {
        success: true,
        sessions: allSessions,
        totalCount: allSessions.length
    };
};
export const deviceAllSessionAPI = async (limit = 100, lastKey = null, eventId = null) => {
    try {
        const queryParams = new URLSearchParams({
            limit: limit.toString()
        });

        if (lastKey) {
            queryParams.append("lastKey", JSON.stringify(lastKey));
        }
        if (eventId) {
    queryParams.append("eventId", eventId);
}


        const url = `${apiDeviceSession}?${queryParams.toString()}`;

        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": getTokenData() ?? "",
            },
        });

        if (response.status === 401) {
            logout();
            throw new Error("Unauthorized");
        }

        if (!response.ok) {
            throw new Error(`API Error: ${response.status}`);
        }

        const result = await response.json();

        return {
            success: result.success,
            sessions: result.sessions || [],
            lastKey: result.lastKey || null
        };

    } catch (error) {
        console.error("deviceAllSessionAPI failed:", error);
        throw error;
    }
};

export var removeDeviceSession = (data) => {
    console.log("removeDeviceSession API", data)
    return fetch(apiDeviceSession, {
        method: "DELETE",
        body: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
            // [tokenHeader]: getUserToken(),
            // [orgTokenHeader]: getOrgUserToken()
        }
    })
        .then(res => res.json())
        .then(
            (result) => {
                console.log(">>Result ", result)
                return result;
            },
            (error) => {
                console.log(">>Eror ---->", error)
                return error;
            }
        )
}
export var deviceNotificationAPI = (data) => {
    return fetch(apiNotification, {
        method: "GET",
        body: JSON.stringify(data),
        headers: {
            Accept: "application/json",
            'Content-Type': 'application/json',
            Authorization: getTokenData(), // Ensure getTokenData() returns a valid token or an empty string if not available
        }
    })
        .then(res => {
            if (res.status === 401) { // Check if the response status is 401 (Unauthorized)
                logout(); // Call logout if unauthorized
                return Promise.reject('Unauthorized'); // Optionally reject the promise to stop further processing
            }
            return res.json();
        })
        .then(
            (result) => {
                return result;
            },
            (error) => {
                return error;
            }
        )
}

export var sendNotificationApi = (data) => {
    return fetch(firebaseApi, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
            'Authorization': firebaseKey,
            'Content-Type': 'application/json',
        }
    })
        .then(res => res.json())
        .then(
            (result) => {
                // alert(result)
                return result;
            },
            (error) => {
                // alert(error)
                return error;
            }
        )
}

//device session count
export const deviceSessionCountAPI = async (id) => {
    try {
        const url = `${apiDeviceSession}${id}/count`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": getTokenData() || "",
            },
        });
        if (response.status === 401) { logout(); throw new Error("Unauthorized"); }
        if (!response.ok) throw new Error(`API Error: ${response.status}`);
        const result = await response.json();
        return { success: result.success, count: result.count };
    } catch (error) {
        console.error("deviceSessionCountAPI failed:", error);
        throw error;
    }
};

//device count
export const deviceCountAPI = async () => {
    try {
        const url = `${apiDeviceData}/count`;
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": getTokenData() || "",
            },
        });
        if (response.status === 401) { logout(); throw new Error("Unauthorized"); }
        if (!response.ok) throw new Error(`API Error: ${response.status}`);
        const result = await response.json();
        return { success: result.success, count: result.count };
    } catch (error) {
        console.error("deviceCountAPI failed:", error);
        throw error;
    }
};